(() => {
  function initialise(root = document) {
    root.querySelectorAll('.mws-mobile-purchase').forEach((bar) => {
      if (bar.dataset.initialised) return;
      const section = document.getElementById(`MainProduct-${bar.dataset.section}`);
      const form = document.getElementById(`product-form-${bar.dataset.section}`);
      const submit = form?.querySelector('[name="add"]');
      const price = document.getElementById(`price-${bar.dataset.section}`);
      const picker = section?.querySelector('variant-selects, variant-radios');
      if (!section || !form || !submit || !price) return;
      bar.dataset.initialised = 'true';
      const button = bar.querySelector('button');
      const priceOutput = bar.querySelector('.mws-mobile-purchase__price');
      const media = matchMedia('(max-width: 749px)');
      let submitVisible = false;
      function needsSize() {
        const size = picker?.querySelector('select[required]');
        return Boolean(size && !size.value);
      }
      function update() {
        const shownPrice = price.querySelector('.price--on-sale .price-item--sale') || price.querySelector('.price-item--regular');
        const prefix = price.querySelector('.mws-from-price')?.textContent.trim();
        priceOutput.textContent = [prefix, shownPrice?.textContent.trim()].filter(Boolean).join(' ');
        const missingSize = needsSize();
        const pending = submit.classList.contains('loading');
        const unavailable = price.classList.contains('visibility-hidden');
        button.textContent = missingSize ? bar.dataset.chooseSize : pending ? bar.dataset.adding : unavailable ? bar.dataset.chooseOptions : submit.querySelector('span')?.textContent.trim();
        button.disabled = !missingSize && !unavailable && (submit.disabled || pending);
        bar.hidden = !media.matches || submitVisible;
      }
      button.addEventListener('click', () => {
        if (needsSize() || price.classList.contains('visibility-hidden')) {
          const control = picker?.querySelector('select[required], select, input:not(:disabled)');
          picker?.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          control?.focus({ preventScroll: true });
          return;
        }
        if (!submit.disabled && !submit.classList.contains('loading')) submit.click();
      });
      new MutationObserver(update).observe(price, { childList: true, subtree: true, attributes: true });
      new MutationObserver(update).observe(submit, { childList: true, subtree: true, attributes: true });
      new IntersectionObserver((entries) => {
        submitVisible = entries[0].isIntersecting;
        update();
      }, { threshold: 0.5 }).observe(submit);
      section.addEventListener('change', update);
      media.addEventListener('change', update);
      update();
    });
    root.querySelectorAll('.mws-size-guide-link').forEach((link) => {
      if (link.dataset.initialised) return;
      link.dataset.initialised = 'true';
      link.addEventListener('click', (event) => {
        const details = document.getElementById(link.hash.slice(1));
        if (!details) return;
        event.preventDefault();
        details.open = true;
        details.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        details.querySelector('summary')?.focus({ preventScroll: true });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise());
  else initialise();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
